import React from "react";
import OtrosServiciosLista from "../OtrosServiciosLista";

export default function OtrosServiciosSection({ data, configuracion }) {
    const { tituloSeccion, subtituloSeccion, imagenFondo, blockType, __component, servicios } = data;
    const ancla = blockType || __component?.split('.')[1] || 'otros-servicios';

    // El componente OtrosServiciosLista ya maneja la obtención de datos de Strapi
    // Solo pasamos los títulos personalizados si existen
    return <OtrosServiciosLista titulo={tituloSeccion} subtitulo={subtituloSeccion} imagenFondo={imagenFondo} id={ancla} servicios={servicios} configuracion={configuracion} />;
}
